module.exports = __webpack_public_path__ + "images/bug_black_large_7ac2a76879b1c46aab7da0bd50299c4b.png";